import React from "react";
import { Box, Typography, Button } from "@mui/material";
import OurStory from "../HomeComponents/OurStory";
import { useTranslation } from "react-i18next";
import tiranaImg from "../../assets/tirana.jpg";
import groupImg from "../../assets/meeting.jpg";
import bottomImg from "../../assets/bottom.jpg";
import slide3 from "../../assets/3.png";
import { NavLink, useLocation } from "react-router-dom";

const About = () => {
  const { t } = useTranslation("about-us");
  const location = useLocation();
  const language = location.pathname.split("/")[1];

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          height: "60vh",
          backgroundImage: `url(${tiranaImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.80)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            color: "white",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3rem", lg: "3.5rem" },
              fontWeight: "600",
              marginBottom: 2,
              maxWidth: "750px",
              color: "#FFFFFF",
              textTransform: "uppercase",
            }}
          >
            {t("title")}
          </Typography>
        <p className="text-base sm:text-lg max-w-4xl mb-8 px-4 sm:px-0">
  {t("hero-text")}
</p>

        </Box>
      </Box>

      <OurStory
        our={t("small_title1")}
        title={t("title1")}
        content={t("content1")}
        showReadMore={false}
        image={groupImg}
      />

      <div className="flex justify-center items-center px-8 lg:px-20">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {[...Array(0)].map((_, idx) => (
            <Box
              key={idx}
              sx={{
                minHeight: "252px",
                minWidth: "310px",
                height: { sm: "252px", md: "328px" },
                width: { sm: "310px", md: "404px" },
                backgroundImage: `url(${slide3})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          ))}
        </div>
      </div>

      <OurStory
        our={t("small_title2")}
        title={t("title2")}
        content={t("content2")}
        showReadMore={false}
        image={groupImg}
      />

      <Box
        sx={{
          position: "relative",
          height: "50vh",
          backgroundImage: `url(${bottomImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.80)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            color: "white",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 500,
              // maxWidth: { sm: "750px", md:"1000px", lg: "1300px" },
              width: "100%",
              px: { xs: "1rem", md: "5rem" },
              my: 2,
              lineHeight: { md: "2.5rem", xs: "1.8rem" },
              color: "#FFFFFF",
              textTransform: "uppercase",
            }}
          >
            {t("bottom-hero-text")}
          </Typography>
          <NavLink
            to={`/${language}/contact`}
            className="hover:underline"
            onClick={() => {
              window.scrollTo({
                top: 0,
              });
            }}
          >
            {" "}
            <Button
              variant="contained"
              sx={{
                backgroundColor: "main",
                ":hover": { backgroundColor: "darkred" },
                mt: 1,
                py: 1.5,
                px: 5,
                borderRadius: "5px",
                fontSize: "1.2rem",
                textTransform: "none",
              }}
            >
              {t("become")}
            </Button>
          </NavLink>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
